"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _container = _interopRequireDefault(require("../../core/container"));
var _clubsList = _interopRequireDefault(require("./clubs-list"));
var _club = _interopRequireDefault(require("./club"));
var _notFound = _interopRequireDefault(require("../../not-found"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _ref = /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  component: _notFound.default
});
function Clubs({
  match: {
    path
  }
}) {
  return /*#__PURE__*/_react.default.createElement(_container.default, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path,
    component: _clubsList.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/:clubID',
    component: _club.default
  }), _ref));
}
var _default = exports.default = Clubs;